module.exports = __webpack_public_path__ + "static/media/cellfinate_certificaciones.40f3bc0c.png";